import * as WorkflowTypes from 'automation-ui-canvas/constants/WorkflowTypes';
import { Record, List } from 'immutable';
import MetaData from 'automation-ui-canvas/data/records/MetaData';
import UnenrollmentSetting from 'automation-ui-canvas/flow/records/properties/UnenrollmentSetting';
import NurtureTimeRange from 'automation-ui-canvas/data/records/NurtureTimeRange';
import AnchorSetting from 'automation-ui-canvas/data/records/AnchorSetting';
import ContactCounts from 'automation-ui-canvas/data/records/ContactCounts';
import ContactListIds from 'automation-ui-canvas/data/records/ContactListIds';
import RecurringSetting from 'automation-ui-canvas/data/records/RecurringSetting';
import EventAnchor from 'automation-ui-canvas/data/records/EventAnchor';
import { ActionTypeToRecord as Action } from 'automation-ui-canvas/data/records/Action';
import CreationSource from 'automation-ui-canvas/data/records/CreationSource';
import UpdateSource from 'automation-ui-canvas/data/records/UpdateSource';
import Validation from 'automation-ui-canvas/data/records/Validation';
import * as ActionTypes from 'automation-ui-canvas/constants/ActionTypes';
const DEFAULT_WORKFLOW = {
  actions: List(),
  allowContactToTriggerMultipleTimes: false,
  canEnrollFromSalesforce: null,
  contactCounts: new ContactCounts(),
  contactListIds: new ContactListIds(),
  creationSource: new CreationSource(),
  description: '',
  enabled: false,
  enrollOnCriteriaUpdate: false,
  errors: null,
  goalCriteria: List(),
  id: null,
  internal: false,
  internalGoalListId: null,
  internalStartingListId: null,
  migrationStatus: null,
  isSegmentBased: true,
  lastUpdatedByUserId: null,
  listening: false,
  metaData: new MetaData(),
  name: '',
  nurtureTimeRange: new NurtureTimeRange(),
  onlyExecOnBizDays: false,
  originalAuthorUserId: null,
  personaTagIds: List(),
  portalId: null,
  recurringSetting: new RecurringSetting(),
  reEnrollmentTriggerSets: [],
  segmentCriteria: List(),
  suppressionListIds: List(),
  triggerSets: List(),
  // may be deprecated in the future
  type: WorkflowTypes.DRIP_DELAY,
  unenrollmentSetting: new UnenrollmentSetting(),
  updateSource: new UpdateSource(),
  validation: new Validation(),
  warnings: null,
  allowEnrollmentFromMerge: false
};
const DEFAULT_DELAY = new Action[ActionTypes.DELAY]({
  anchorSetting: new AnchorSetting(),
  delayMillis: 0,
  name: ''
});
const DEFAULT_STATIC_ANCHOR = Object.assign({}, DEFAULT_WORKFLOW, {
  actions: List([DEFAULT_DELAY]),
  eventAnchor: new EventAnchor(),
  type: WorkflowTypes.STATIC_ANCHOR
});
const DEFAULT_PROPERTY_ANCHOR = Object.assign({}, DEFAULT_STATIC_ANCHOR, {
  type: WorkflowTypes.PROPERTY_ANCHOR
});
export default {
  [DEFAULT_WORKFLOW.type]: Record(DEFAULT_WORKFLOW, 'ClassicWorkflow'),
  [DEFAULT_STATIC_ANCHOR.type]: Record(DEFAULT_STATIC_ANCHOR, 'ClassicWorkflowBasedOnStaticDate'),
  [DEFAULT_PROPERTY_ANCHOR.type]: Record(DEFAULT_PROPERTY_ANCHOR, 'ClassicWorkflowBasedOnDateProperty')
};